import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Honorarios',
    sin: 'El de la OS o menos',
    con: 'Sistema de valor hora real calculado'
  }, {
    sit: 'Cobros',
    sin: 'Incómodos e irregulares',
    con: 'Reclamos modelo en 4 niveles'
  }, {
    sit: 'Informes',
    sin: '2-3 horas desde cero',
    con: 'Copy-paste listo en 15 minutos'
  }, {
    sit: 'Respaldo legal',
    sin: 'Sin contrato sólido',
    con: 'Contrato élite con 12 cláusulas'
  }, {
    sit: 'Crisis documentadas',
    sin: 'Sin acta de respaldo',
    con: 'Acta de incidente legal incluida'
  }];
  const modules = [{
    icon: '🔍',
    title: 'Módulo 1 — El Método Zero-Stress',
    desc: 'Registro de sesión en 2 minutos · Sistema de archivo digital · Cómo pasar del registro al informe en 15 minutos · Nunca más reconstruir sesiones de memoria'
  }, {
    icon: '📊',
    title: 'Módulo 2 — Contrato Élite',
    desc: 'Las 12 cláusulas que todo contrato de AT debe tener · Deslinde de responsabilidad · Política de ausencias · Protocolo ante crisis · Cláusula de actualización de honorarios'
  }, {
    icon: '📄',
    title: 'Módulo 3 — Biblioteca de Informes Copy-Paste',
    desc: '6 modelos completos listos para completar · TEA · Gerontología · Salud mental · Integración escolar · Alta de caso · Informe de inicio'
  }, {
    icon: '🧠',
    title: 'Módulo 4 — Banco de 100 Frases Técnicas',
    desc: 'Conectores profesionales por área · Frases para describir avances, dificultades y estrategias · Los 15 errores más frecuentes y cómo corregirlos'
  }, {
    icon: '🚨',
    title: 'Módulo 5 — Gestión de Crisis Documentada',
    desc: 'Acta de incidente legal · Registro de medicación · Comunicación de efectos adversos sin ser médico · Emails modelo para el equipo tratante'
  }, {
    icon: '📨',
    title: 'Módulo 6 — Comunicación Profesional con el Equipo',
    desc: 'Mensajes modelo por nivel de urgencia · Cómo hablar con psiquiatras y psicólogos · Emails de coordinación que generan respuesta'
  }, {
    icon: '💰',
    title: 'Módulo 7 — Tu Valor Hora Real',
    desc: 'Calculadora de honorario mínimo · Proyección de ingresos · Por qué el 80% de los ATs cobra por debajo de su costo real'
  }, {
    icon: '📮',
    title: 'Módulo 8 — Hoja de Ruta de Reclamos',
    desc: 'Protocolo de 4 niveles · Nota de reclamo formal modelo · Cómo presentar ante la Superintendencia de Servicios de Salud'
  }, {
    icon: '✅',
    title: 'Módulo 9 — Auditoría Interna Mensual',
    desc: '30 puntos de control administrativo · Cierre de mes perfecto · Nunca más un legajo rechazado por documentación incompleta'
  }];
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="text-center mb-6" data-id="element-31">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-32">
            🚀 ¿QUÉ AGREGA AT MASTER-DOC™?
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto" data-id="element-33">
            Para el AT que ya tiene las herramientas clínicas y ahora quiere una
            práctica que pague lo que merece.
          </p>
        </div>

        <div className="space-y-2 mb-8" data-id="element-34">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark-card border border-dark-border rounded-xl p-3 grid grid-cols-3 gap-2 items-center" data-id="element-35">
              <div className="font-bold text-white text-sm" data-id="element-36">{row.sit}</div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-37">
                <X className="w-3.5 h-3.5 text-red-400 flex-shrink-0" data-id="element-38" />
                <span className="text-gray-400" data-id="element-39">{row.sin}</span>
              </div>
              <div className="flex items-center space-x-1.5 text-xs" data-id="element-40">
                <Check className="w-3.5 h-3.5 text-brand flex-shrink-0" data-id="element-41" />
                <span className="text-white font-medium" data-id="element-42">{row.con}</span>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-4" data-id="element-43">
          <h3 className="text-lg font-black text-white" data-id="element-44">
            ✅ INCLUYE 9 MÓDULOS:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-45">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-dark border border-dark-border p-3 rounded-xl flex items-start space-x-2" data-id="element-46">
              <span className="text-lg" data-id="element-47">{mod.icon}</span>
              <div data-id="element-48">
                <h4 className="font-bold text-brand text-xs" data-id="element-49">{mod.title}</h4>
                <p className="text-gray-400 text-xs" data-id="element-50">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-51">
          <p className="text-gray-300 italic text-sm max-w-xl mx-auto leading-relaxed" data-id="element-52">
            "Si los 6 Tomos te dieron las herramientas para ser un AT
            extraordinario clínicamente, AT MASTER-DOC™ te da las herramientas
            para ser un AT extraordinario económicamente."
          </p>
        </motion.div>
      </div>
    </section>;
}